export default "__VITE_ASSET__BSCM2M_3__"